module.exports = __webpack_public_path__ + "ba229db0793a696054596258082fb83c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-18.png
// module id = 2938
// module chunks = 0